<div class="step" [formGroup]="step"
    [ngClass]="{'error': validityResult && !workflowStep?.isWarning, 'warning': validityResult && workflowStep?.isWarning}"
    (contextmenu)="showMenu($event)" (dblclick)="!isMouseOver ? edit() : null"
    [attr.data-automation-id]="'workflow-step-panel-step-' + (stepNumber + 1) + (queryType === 'Term Query' ? '-term' : '-date-range') + '-query-container'">
    <div class="workflow-row">
        <div class="title-row">
            <span *ngIf="selectedQuery === 'No query'" class="title"
                data-automation-id="workflow-step-panel-no-query-label">Step {{stepNumber + 1}} </span>
            <span *ngIf="selectedQuery !== 'No query'" class="title">Step {{stepNumber + 1}}: {{queryType}} <span
                    *ngIf="resultCount">(<span class="link" (click)="navigateToDocList()">{{resultCount |
                        number}}</span>)</span>
                <i [class]="getIconClass(workflowStep)" [hidden]="!validityResult"
                    [ngClass]="{'fa-exclamation-triangle': workflowStep?.isWarning && !hoverIcon, 'fa-exclamation-circle': !workflowStep?.isWarning && !hoverIcon, 'fa-info': hoverIcon}"
                    [attr.title]="workflowStep?.isWarning ? 'Warning. Click for details.' : 'Error. Click for details.'"
                    (click)="iconClick(validityResult, workflowStep?.isWarning)"
                    [attr.data-automation-id]="'workflow-step-panel-step-' + (stepNumber + 1) + '-' + (workflowStep?.isWarning ? 'warning' : 'error') + '-icon'"
                    (mouseenter)="hoverIcon = true"
                    (mouseleave)="hoverIcon = false"></i></span>
            <div class="paired-buttons" *ngIf="hasCreatePermissions && !running">
                <div class="families-panel" *ngIf="selectedQuery !== 'No query'">
                    <span [ngClass]="[families === true ? 'field-option-selected' : 'field-option']"
                        data-automation-id="workflow-step-panel-family-option-panel-families">Families</span>
                    <span class="option-spacing"></span>
                    <span [ngClass]="[metadata === true ? 'field-option-selected' : 'field-option']"
                        data-automation-id="workflow-step-panel-family-option-panel-metadata">Metadata</span>
                    <span class="option-spacing" [hidden]="searchType !== 'ADVANCED'"></span>
                    <span [hidden]="searchType !== 'ADVANCED'"
                        [ngClass]="[synonyms === true ? 'field-option-selected' : 'field-option']"
                        data-automation-id="workflow-step-panel-family-option-panel-synonyms">Synonyms</span>
                    <span class="option-spacing"></span>
                    <span [ngClass]="[generateReports === true ? 'field-option-selected' : 'field-option']"
                        data-automation-id="workflow-step-panel-family-option-panel-generate-reports">Reports</span>
                </div>
                <button type="button" class="secondary-button left-button" [disabled]="locked" (click)="edit()"
                    (mouseover)="isMouseOver=true" (mouseleave)="isMouseOver=false"
                    data-automation-id="workflow-step-panel-button-edit-button">
                    <i class="fa fa-pencil menu-item-icon color-blue-01"></i>Edit ...</button>
                <button type="button" class="secondary-button right-button" [disabled]="locked"
                    (click)="showMenu($event)" (mouseover)="isMouseOver=true" (mouseleave)="isMouseOver=false"
                    data-automation-id="workflow-step-panel-button-edit-button">
                    <i class="fa fa-caret-down"></i></button>
            </div>
        </div>
        <div class="content-row">
            <res-generic-input #input [queryString]="selectedQueryDisplayValue" [readonly]="true"
                [automationId]="'workflow-step-panel'"
                [ngClass]="{'no-query': selectedQueryDisplayValue === 'No query'}">
            </res-generic-input>
        </div>
    </div>
    <div class="description-container">
        <div class="input-section report">
            <div class="labels desc-panel">
                <label for="step.description">Report Description:</label>
            </div>
            <div class="inputs textarea-panel">
                <textarea [readonly]="locked" [attr.disabled]="!hasCreatePermissions ? 'disabled' : null"
                    formControlName="description" maxlength="255" (mouseover)="isMouseOver=true"
                    (mouseleave)="isMouseOver=false"
                    data-automation-id="workflow-step-panel-report-description-input"></textarea>
            </div>
        </div>
    </div>

    <res-context-menu #editMenu>
    </res-context-menu>

</div>